import Cookies from 'js-cookie';
import Switch from 'weatherstar-switch';

class rgpd {
  constructor(context) {
    /* GTAG base config */
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());

    let cookie = Cookies.get('rgpd');
    if (!cookie) {
      cookie = {
        'displayed': false,
        'userInteraction': false,
        'system': true,
        'tracking': false
      };
      Cookies.set('rgpd', JSON.stringify(cookie), { expires: 390 });
    } else {
      cookie = JSON.parse(cookie);
    }

    const popup = context.querySelector('#cookie-popup');
    if (popup) {

      const cookiePrefix = popup.dataset.cookieName;
      const ga = popup.dataset.cookieGa;
      const hash = window.location.hash;

      const $config = popup.querySelector('.cookie-form__config');
      const $btnAccept = popup.querySelector('.cookie-form__save');
      const $btnDecline = popup.querySelector('.cookie-form__decline');
      const $btnConfigure = popup.querySelector('.cookie-form__configure');

      if (cookie.displayed && !cookie.userInteraction) {
        cookie.tracking = true;
      }

      if (!cookie.displayed) {
        popup.classList.add('show');
        cookie.displayed = true;
        Cookies.set('rgpd', JSON.stringify(cookie), { expires: 390 });

        new Switch(popup.querySelector('#cookie-popup-system'), { size: 'small', checked: true, disabled: true });
        new Switch(popup.querySelector('#cookie-popup-tracking'), { size: 'small', checked: true });

        $btnConfigure.addEventListener('click', (e) => {
          e.preventDefault();
          $config.classList.toggle('show');
          return false;
        });

        $btnAccept.addEventListener('click', (e) =>  {
          e.preventDefault();
          popup.classList.remove('show');
          cookie.tracking = popup.querySelector('#cookie-popup-tracking').checked;
          cookie.userInteraction = true;
          Cookies.set('rgpd', JSON.stringify(cookie), { expires: 390 });
          return false;
        });

        $btnDecline.addEventListener('click', (e) => {
          e.preventDefault();
          popup.classList.remove('show');
          cookie.tracking = false;
          cookie.userInteraction = true;
          Cookies.set('rgpd', JSON.stringify(cookie), { expires: 390 });
          return false;
        });
      }

      if (cookie.tracking) {
        gtag('config', ga);
        fbq('consent', 'grant');
      } else {
        gtag('config', ga, {
          client_storage: 'none'
        });
      }

    }
  }
};

export default rgpd;